// Self-hosted fonts — no external font request at runtime. Weights match what's
// actually used across the site (see tailwind.config.js fontFamily comments).
import '@fontsource/cormorant-garamond/300.css';
import '@fontsource/cormorant-garamond/400.css';
import '@fontsource/cormorant-garamond/400-italic.css';
import '@fontsource/cormorant-garamond/500.css';
import '@fontsource/cormorant-garamond/700.css';
import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/inter/wght-italic.css';

// Import global styles
import './src/styles/global.css';

import React from 'react';
import { CartProvider } from './src/components/cart/CartContext';

// Gatsby Browser APIs
export { wrapPageElement } from 'gatsby-plugin-react-i18next';

export const wrapRootElement = ({ element }) => (
  <CartProvider>{element}</CartProvider>
);

export const shouldUpdateScroll = () => [0, 0];
